import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Sparkles, ChevronDown, ChevronUp, Loader2, Settings } from 'lucide-react';
import { NARRATIVE_SECTIONS } from './constants';

export function PlannerNarrative({ narrative, loading, expanded, onToggle, onGenerate }) {
  return (
    <Card data-testid="planner-narrative">
      <CardHeader className="pb-2 flex flex-row items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-amber-500" />
          <CardTitle className="text-sm font-semibold text-[#0F2040]">AI Resource Plan Narrative</CardTitle>
        </div>
        <div className="flex items-center gap-2">
          {narrative && (
            <button onClick={onToggle} className="text-slate-400 hover:text-slate-600 transition-colors" data-testid="narrative-toggle">
              {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </button>
          )}
          <Button size="sm" onClick={onGenerate} disabled={loading} className="bg-[#0F2040] hover:bg-[#1A3055] text-white" data-testid="generate-narrative-btn">
            {loading ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5 mr-1.5" />}
            {loading ? 'Generating...' : narrative ? 'Regenerate' : 'Generate Narrative'}
          </Button>
        </div>
      </CardHeader>
      {!narrative && !loading && (
        <CardContent><p className="text-xs text-slate-400 italic">Generate an AI-powered narrative covering executive summary, staffing, risks, and recommendations.</p></CardContent>
      )}
      {loading && (
        <CardContent>
          <div className="flex items-center gap-3 py-6 justify-center">
            <Loader2 className="w-5 h-5 animate-spin text-[#0F2040]" />
            <span className="text-sm text-slate-500">Analyzing resource plan...</span>
          </div>
        </CardContent>
      )}
      {narrative && expanded && (
        <CardContent className="space-y-5 pt-1">
          {NARRATIVE_SECTIONS.map(({ key, title, icon: Icon }) => {
            const content = narrative[key];
            if (!content) return null;
            return (
              <div key={key} data-testid={`narrative-${key}`}>
                <div className="flex items-center gap-2 mb-1.5">
                  <Icon className="w-3.5 h-3.5 text-slate-400" />
                  <h4 className="text-xs font-semibold text-[#0F2040] uppercase tracking-wide">{title}</h4>
                </div>
                <p className="text-sm text-slate-700 leading-relaxed pl-5.5">{content}</p>
              </div>
            );
          })}
          {narrative.recommendations && narrative.recommendations.length > 0 && (
            <div data-testid="narrative-recommendations">
              <div className="flex items-center gap-2 mb-1.5">
                <Settings className="w-3.5 h-3.5 text-slate-400" />
                <h4 className="text-xs font-semibold text-[#0F2040] uppercase tracking-wide">Recommendations</h4>
              </div>
              <ul className="space-y-2 pl-5.5">
                {narrative.recommendations.map((rec, i) => (
                  <li key={`rec-${rec.slice(0, 30)}`} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#0F2040] text-white text-[10px] font-bold mt-0.5 shrink-0">{i + 1}</span>
                    <span className="leading-relaxed">{rec}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}
